"use strict";
// @lightwaves/hooks - Reusable React hooks for web applications
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCookieConsent = exports.useLocalStorage = exports.usePrefersReducedMotion = exports.useIsMobile = exports.useScrollLock = void 0;
var useScrollLock_1 = require("./useScrollLock");
Object.defineProperty(exports, "useScrollLock", { enumerable: true, get: function () { return useScrollLock_1.useScrollLock; } });
var useIsMobile_1 = require("./useIsMobile");
Object.defineProperty(exports, "useIsMobile", { enumerable: true, get: function () { return useIsMobile_1.useIsMobile; } });
var usePrefersReducedMotion_1 = require("./usePrefersReducedMotion");
Object.defineProperty(exports, "usePrefersReducedMotion", { enumerable: true, get: function () { return usePrefersReducedMotion_1.usePrefersReducedMotion; } });
var useLocalStorage_1 = require("./useLocalStorage");
Object.defineProperty(exports, "useLocalStorage", { enumerable: true, get: function () { return useLocalStorage_1.useLocalStorage; } });
var useCookieConsent_1 = require("./useCookieConsent");
Object.defineProperty(exports, "useCookieConsent", { enumerable: true, get: function () { return useCookieConsent_1.useCookieConsent; } });
